import {
  blue,
  ecoleFrancaiseGreen,
  green,
  lightBlue,
  lighterGreen,
  lightGrey,
  lightOrange,
  lightYellow,
  mediumGreen,
  orange,
  fontFamilyRoboto,
  yellow,
} from '@components/hoc/Theme/Theme.styled';
import { TrainingTypes } from '@config/enums/FormationTypeEnum';
import styled from 'styled-components';

// Styled components
export const RadioIconContainer = styled.div.attrs({
  className: 'RadioIconContainer',
})`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 14px;

  @media (max-width: 1024px) {
    max-height: 100%;
    padding: 0;
  }
`;

export const Option = styled.label.attrs((props) => ({
  className: props.$checked ? 'RadioOptionChecked' : 'RadioOption',
}))`
  letter-spacing: normal;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  max-height: max-content;
  min-height: 4rem;
  margin: 0;
  border-radius: 5px;
  border: ${(props) =>
    props.$checked ? '1px solid #00D2A4' : '1px solid rgb(240, 240, 240)'};
  ;
  font-size: 16px !important;
  font-family: ${fontFamilyRoboto};
  z-index: 2;
  column-gap: 1rem;
  padding: 0 1rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: start;
    padding: 1rem 1rem;
    gap: 15px;
  }

  &:hover {
    transition: 0.1s;
    box-shadow: 0 0 0 2px ${ecoleFrancaiseGreen};
  }

  font-weight: ${(props) =>
    props.$checked ? '800 !important' : '700 !important'};
`;

export const GreenChip = styled.span`
  height: 50%;
  min-width: max-content;
  font-size: 12px !important;
  font-family: ${fontFamilyRoboto};
  color: ${mediumGreen};
  background-color: ${lighterGreen};
  opacity: 0.8;
  border-radius: 8px;
  padding: 3px 7px;
  font-weight: 400;
`;

export const BlueChip = styled.span`
  height: 50%;
  font-size: 12px !important;
  font-family: ${fontFamilyRoboto};
  color: ${blue};
  background-color: ${lightBlue};
  opacity: 0.8;
  border-radius: 8px;
  padding: 3px 7px;
  vertical-align: middle;
  font-weight: 400;
`;

export const Input = styled.input`
  position: fixed;
  opacity: 0;
  pointer-events: none;
  ${(props) => (props.$iserror ? 'fill:#f11a48' : 'fill:#60bead')};

  &:hover {
    background-color: '#009E7C';
    border: 2px solid #60bead;
  }

  &:checked {
    background-color: #60bead;
    border: 3px solid #60bead;
  }
`;

export const TagsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 14rem;

  & > :last-child {
      margin-right: 0;
  }
`;

export const TrainingTypeChip = styled.span`
  background-color: ${ props => {
    switch (props.$trainingType) {
      case TrainingTypes.diplomantes:
        return lightOrange;

      case TrainingTypes.certifiantes:
        return lightGrey;

      case TrainingTypes.accelerees:
        return lightYellow;

      default:
        return '';
    }
  }};

  color: ${ props => {
    switch (props.$trainingType) {
      case TrainingTypes.diplomantes:
        return orange;

      case TrainingTypes.certifiantes:
        return green;

      case TrainingTypes.accelerees:
        return yellow;

      default:
        return '';
    }
  }};

  font-size: 12px !important;
  font-family: ${fontFamilyRoboto};
  font-weight: 400;
  border-radius: 50px;
  padding: 3px 10px;
`;
